import { defineComponent as i, computed as p } from "vue";
import a from "../../../csr_phone_number/ui/components/index.js";
import c, { DropdownMenuItem as t } from "@ado/dropdown-menu-ld";
import { launchLiveHelp as s } from "../types/index.js";
import { submitInternalEvent as o } from "@ado/tracking-library";
import { TRACKING_EVENTS as r } from "../../../shared/data/tracking/types/index.js";
import "@ado/dropdown-menu-ld/style.css";
import { useBaseApplicationTranslation as u } from "../../../shared/libraries/local-translations/index.js";
const h = i({
  name: "HeaderHelp",
  components: {
    CsrPhoneNumberComponent: a,
    DropdownMenuComponent: c
  },
  props: {
    config: {
      type: Object,
      required: !0
    },
    csr: {
      type: Object,
      required: !0
    },
    showHelpCenter: {
      type: Boolean,
      default: !0
    }
  },
  setup(e) {
    const m = p(() => [
      t.newLinkItem(
        1,
        n("header.email-us"),
        e.config.ticketCenterURL
      ).setOnClickHandler(
        () => o(r.HEADER_HELP_DROPDOWN_EMAIL_US_CLICK)
      ),
      t.newButtonItem(2, n("header.chat-online"), () => {
        o(
          r.HEADER_HELP_DROPDOWN_CHAT_ONLINE_CLICK
        ), s(e.config.live_help_path ?? "");
      }),
      t.newLinkItem(
        3,
        n("help-center"),
        e.config.contactPage
      ).markAsIntendedForShowingInNewTab().setOnClickHandler(
        () => o(
          r.HEADER_HELP_DROPDOWN_HELP_CENTER_CLICK
        )
      ).setIsVisible(e.showHelpCenter),
      t.newCustomItem(4, "csr-phone-number")
    ]), { t: n } = u();
    return {
      menuItems: m,
      t: n
    };
  }
});
export {
  h as default
};
//# sourceMappingURL=index22.js.map
